import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-confirm-remove-tax',
  templateUrl: './confirm-remove-tax.component.html',
  styleUrls: ['./confirm-remove-tax.component.scss']
})
export class ConfirmRemoveTaxComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
